import { ReactNode, useEffect, useState } from "react";
import { Button, Dropdown, Input, MenuProps } from "antd";
import { SearchIcon } from "../../Icons/SearchIcon";
import "./style.scss";
import { useGetData } from "../../Network/useGetQueryData";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../redux/reduxSlices/userSlice";
import SearchDropdown from "./RequestSearchMenu";
import { NotificationCenter } from "../../pages/NotificationsCenter";
import { useTranslation } from "react-i18next";
import EnvBadge from "../EnvBadge";

type Props = {
  title: string;
  headerAction?: {
    actionTitle?: string;
    onAction?: () => void;
  };
  headerFilter?: ReactNode;

  search?: {
    placeholder?: string;
    searchAction?: (value: any) => void;
    btnLoading?: boolean;
  };
  searchMenu?: boolean;
  backIcon?: ReactNode;
};

export const Header = ({
  title,
  search,
  backIcon,
  searchMenu,
  headerFilter,
  headerAction,
}: Props) => {
  const userExist = localStorage.getItem("user");
  const userInfo = useSelector((state: any) => state.user.user);
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const { data: user } = useGetData<{
    data: any;
  }>({
    queryKey: ["user"],
    url: "/auth/me",
    options: {
      enabled: !!!userExist && !!!userInfo,
      queryKey: ["user"],
    },
  });

  const toggleLanguage = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
  };

  useEffect(() => {
    if (user) dispatch(setUser(user?.data));
  }, [user]);

  const { data } = user || {};
  const { firstName, lastName } = data || userInfo || {};
  const items: MenuProps["items"] = [
    {
      label: firstName
        ? `${firstName} ${lastName ? lastName : ""}`
        : t("header.medhubUser"),
      key: "3",
    },
    {
      type: "divider",
    },
    {
      label: (
        <p onClick={toggleLanguage}>{i18n.language === "ar" ? "EN" : "AR"}</p>
      ),
      key: "10",
    },
    {
      label: (
        <p
          onClick={() => {
            dispatch(setUser(null));
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            window.location.reload();
          }}
        >
          {t("header.logout")}
        </p>
      ),
      key: "0",
    },
  ];

  return (
    <div className="header-wrapper">
      <p>
        {backIcon && backIcon} {title}
        <EnvBadge />
      </p>

      <div className="right-header">
        {headerFilter && headerFilter}
        {headerAction && (
          <Button type="primary" onClick={headerAction?.onAction}>
            {headerAction?.actionTitle}
          </Button>
        )}
        {search && !searchMenu && (
          <div className="header-search">
            <Input
              size="large"
              placeholder={search?.placeholder || t("header.search")}
              prefix={<SearchIcon />}
              onChange={(e) => search?.searchAction?.(e.target.value)}
            />
          </div>
        )}
        {searchMenu && <SearchDropdown search={search} />}
        <NotificationCenter />

        <div className="header-menu">
          <Dropdown menu={{ items }} trigger={["click"]}>
            <span className="profile-menu">
              <span>{firstName?.charAt(0)}</span>
              <span>{lastName?.charAt(0)} </span>
            </span>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};
